import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63b16bea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pt-24" }
const _hoisted_2 = { class: "max-w-screen-2xl px-4 md:px-8 mx-auto" }
const _hoisted_3 = { class: "bg-white py-6 sm:py-8 lg:py-12 rounded-lg shadow-md" }
const _hoisted_4 = { class: "mx-auto max-w-screen-2xl px-4 md:px-8" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-10 md:mb-16 text-center" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "mb-4 text-2xl font-bold text-gray-800 md:mb-6 lg:text-3xl" }, " Quem está entregando o Documento? "),
  /*#__PURE__*/_createElementVNode("p", { class: "mx-auto max-w-screen-md text-gray-500 md:text-lg" }, " Clique no seu nome abaixo. ")
], -1))
const _hoisted_6 = { class: "mb-6 flex flex-col gap-4" }
const _hoisted_7 = { class: "w-full relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "filtroNomeMotoboy",
  class: "block text-sm font-medium text-gray-700 mb-1"
}, "Filtrar por Nome", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  })
], -1))
const _hoisted_10 = {
  key: 0,
  class: "text-center text-red-500 mb-4"
}
const _hoisted_11 = {
  key: 1,
  class: "text-center text-gray-600 mb-4"
}
const _hoisted_12 = {
  key: 2,
  class: "text-center text-gray-600 mb-4"
}
const _hoisted_13 = {
  key: 3,
  class: "flex justify-center mb-6"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-8 w-8 border-t-2 border-blue-500" }, null, -1))
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "flex flex-col gap-6" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-6 w-6 text-gray-500 mr-3",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })
], -1))
const _hoisted_20 = { class: "text-lg font-semibold text-gray-800" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5 text-gray-400",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                id: "filtroNomeMotoboy",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filtroNomeMotoboy) = $event)),
                type: "text",
                placeholder: "Digite o nome do motoboy...",
                class: "w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-400 pr-10"
              }, null, 512), [
                [_vModelText, _ctx.filtroNomeMotoboy]
              ]),
              _hoisted_9
            ])
          ]),
          (_ctx.errorMessage)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorMessage), 1))
            : (_ctx.motoboysFiltrados.length > 0)
              ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Exibindo " + _toDisplayString(_ctx.motoboysFiltrados.length) + " motoboy(s)", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_12, "Nenhum motoboy encontrado para os critérios.")),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.motoboysFiltrados, (motoboy) => {
              return (_openBlock(), _createElementBlock("div", {
                key: motoboy.id_fun,
                onClick: ($event: any) => (_ctx.selecionarMotoboy(motoboy)),
                class: "w-full flex items-center justify-between rounded-lg bg-gray-50 p-4 sm:p-6 shadow-md hover:shadow-lg transition-shadow duration-200 cursor-pointer"
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("h3", _hoisted_20, _toDisplayString(motoboy.nome_fun), 1)
                ]),
                _hoisted_21
              ], 8, _hoisted_17))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}